import Experience from './Experience.js';
import EventEmitter from './Utils/EventEmitter.js';

export default class PreLoader extends EventEmitter {
  constructor() {
    super();

    this.experience = new Experience();
    this.camera = this.experience.camera;
    this.scene = this.experience.scene;
    this.sounds = this.experience.sounds;
    this.resources = this.experience.resources;
    this.sizes = this.experience.sizes;

    this.overlay = document.querySelector('.overlay');
    // Progress
    this.resources.on('progress', () => {
      this.progressRatio =
        this.resources.groups.current.loaded /
        this.resources.groups.current.toLoad;

      document.getElementById(
        'progressPercentage'
      ).innerHTML = `Loading ${Math.trunc(this.progressRatio * 100)}%...`;
    });

    //Loaded
    this.resources.on('end', () => {
      window.setTimeout(() => {
        this.start();
      }, 1500);
    });
  }

  start = async () => {
    this.overlay.classList.add('fade');
    window.setTimeout(() => {
      this.overlay.remove();
    }, 2000);
    this.camera.camControls.toDefault();
    this.trigger('start');
  };

  sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }
}
